import styled from "styled-components";

export const StyledWrapper = styled.div`
  padding: 40px;
  width: 100%;
  color: ${({ theme }) => theme.colors.neutralsText};
  background-color: ${({ theme }) => theme.colors.neutralsBackgroundInactive};
  border-radius: 4px;

  .panel-title {
    ${({ theme }) => theme.fontStyles.DesktopHeadlinesH5}
  }

  .panel-stats {
    margin-top: 40px;
    color: ${({ theme }) => theme.colors.neutralsTextLight};
    ${({ theme }) => theme.fontStyles.CommentsBody}
    display: flex;
    flex-wrap: wrap;
  }

  .panel-stat {
    margin-top: 12px;
    padding-right: 10px;
    width: 33.3%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .panel-stat-value {
    margin-right: 6px;
    padding: 6px 12px;
    color: ${({ theme }) => theme.colors.primaryTextHover};
    font-weight: 500;
    background-color: ${({ theme }) => theme.colors.primaryRulerTint15};
    border-radius: 4px;
  }
`;
